import './App.css';
import Markdown from './Markdown';

function App() {
  return (
    <div>
      <Markdown />
    </div>
  );
}

export default App;
